'use client';

import dynamic from 'next/dynamic';

// Dynamic imports for client-only components
const ScrollTopButton = dynamic(() => import('@/components/ScrollTopButton'), {
  ssr: false,
  loading: () => null,
});

const GoogleTag = dynamic(() => import('@/components/GoogleTag'), {
  ssr: false,
  loading: () => null,
});

export { ScrollTopButton, GoogleTag };
